import { Listing } from '@df/catalog-ui/listing/listing';
import { ListingSort } from '@df/catalog-ui/listing/sort/listing-sort';
import { IListingSortOptionAttribute, ListingSortAttributeEngine } from '@df/catalog-ui/listing/sort/listing-sort-attribute-engine';
import { Model } from '@df/catalog/model';

export class ListingSortAttributeEngineDecorator<T extends Model = Model> extends ListingSortAttributeEngine {
    public override sort(collection: T[], option: IListingSortOptionAttribute, listing: Listing, cb: (models: T[]) => void): void {
        const heroProducts = listing.config?.source?.data?.heroProducts || [];

        if (heroProducts.length) {
            // push hero products to the bottom before setting up their final position,
            // its needed because otherwise we can remove products form top after setting other hero position and breaking the order this way
            collection = collection?.sort((a, b) => {
                if (heroProducts.find(i => i.product_id === a.id)) return 1;
                if (heroProducts.find(i => i.product_id === b.id)) return -1;
                return 0;
            });
        }

        heroProducts.forEach(heroProduct => {
            const matchingProduct = collection.find(product => product.id === heroProduct.product_id);

            if (matchingProduct) {
                const insertIndex = heroProduct.position - 1;
                collection.splice(collection.indexOf(matchingProduct), 1);
                collection.splice(insertIndex, 0, matchingProduct);
            }
        });

        super.sort(collection, option, listing, cb);
    }
}

ListingSort.engines['attribute'] = new ListingSortAttributeEngineDecorator();
